import nameModelValidator from 'forms/shared/validators/models/name/name';
import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { foreignBusinessAffairsRelationshipOptions } from 'constants/enums/foreignBusinessOptions';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { foreignBusinessInvolvementOptions } from 'constants/enums/foreignActivityOptions';
import { ForeignBusinessVenturesItemModel } from '../types';

export const foreignBusinessVenturesItemValidator: ValidateJSModel<ForeignBusinessVenturesItemModel> = {
  Name: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, model: { validator: pvqNameModelValidator } };
    }

    return { presence: true, model: { validator: nameModelValidator } };
  },

  AddressNotApplicable: {},

  Address: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes?.AddressNotApplicable?.applicable === false) {
        return {};
      }

      if (attributes?.InUsaNotApplicable?.applicable === false) {
        return {};
      }

      if (attributes?.Address?.country?.valueOf() !== 'United States') {
        return {
          presence: true,
          location: {
            validator: pvqLocationModelValidator,
            requireStreet: false,
          }
        };
      }

      return {
        presence: true,
        location: {
          validator: pvqLocationModelValidator,
          requireStreet: true,
        }
      };
    }

    return { presence: true, location: { validator: locationAddressModelValidator } };
  },

  CitizenshipNotApplicable: {},

  Citizenship: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.CitizenshipNotApplicable?.applicable === false) {
      return {};
    }

    return { hasValue: true, country: true };
  },

  Description: { hasValue: true },

  Relationship: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { hasValue: true };
  },

  RelationshipPvq: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: foreignBusinessAffairsRelationshipOptions,
          },
        }
      };
    }

    return {};
  },

  RelationshipOtherExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.RelationshipPvq?.value === 'Other') {
      return { hasValue: true };
    }

    return {};
  },

  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Association: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { hasValue: true };
  },

  Position: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { hasValue: true };
  },

  Service: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { hasValue: true };
  },

  FinancialSupportEstimated: {},

  Support: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) ) {
      if (attributes?.Role?.value === 'I provided financial support') {
        return {
          presence: true,
          model: {
            validator: currencyModelValidator,
          },
        };
      }
      return {};
    }
    return { hasValue: true };
  },

  Compensation: { hasValue: true },

  Role: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: foreignBusinessInvolvementOptions,
          },
        }
      };
    }

    return {};
  },

  RoleOtherExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.Role?.value === 'Other') {
      return { hasValue: true };
    }

    return {};
  },
};
